module.exports = __webpack_public_path__ + "img/fig04.0eee807d.jpg";